import { render, staticRenderFns } from "./PengajuanBudget.vue?vue&type=template&id=bff48116&scoped=true"
import script from "./PengajuanBudget.vue?vue&type=script&lang=js"
export * from "./PengajuanBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff48116",
  null
  
)

export default component.exports